<template>
  <v-footer app class="footer" color="white" absolute>
    <div class="mx-auto">
      <img src="../assets/logofooter.png" alt="logofooter" class="logo" />
    </div>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped lang="scss" >
.logo {
  width: 280px;
}
@media only screen and (max-width: 600px) {
  .logo {
    width: 225px;
  }
}
</style>